import React from "react";
import { Checkbox } from "@mui/material";
import {
	CustomTableCell,
	CustomTableRow,
	CustomTooltip,
	icon,
	IconComponent,
} from "../../../../../../common/components";
import styles from "./ToolRow.module.css";
import { translate } from "../../../../../../common/providers";

const ToolRow = ({ isChecked, isSaving, onCheckTool, tool }) => (
	<CustomTableRow key={tool.id}>
		<CustomTableCell>
			<Checkbox
				checked={isChecked}
				disabled={isSaving || (tool?.deprecated && !isChecked)}
				onChange={() => onCheckTool(tool.id)}
			/>
		</CustomTableCell>
		<CustomTableCell>
			<div className={`${styles.name__cell} ${styles["text--bold"]}`}>
				{tool?.deprecated && (
					<CustomTooltip title={translate("dsi.agents.tool.warning.deprecated")}>
						<IconComponent color="var(--amber-500)" icon={icon.faExclamationTriangle} />
					</CustomTooltip>
				)}
				{tool.methodName}
			</div>
		</CustomTableCell>
		<CustomTableCell>{tool.description}</CustomTableCell>
		<CustomTableCell>
			<div className={`${styles.name__cell}`}>
				{Object.entries(tool.input).map(([key, value]) => (
					<div key={key}>
						{key} : {value}
					</div>
				))}
			</div>
		</CustomTableCell>
		<CustomTableCell>{tool.output}</CustomTableCell>
		<CustomTableCell>{(tool.writesInDb && "true") || "false"}</CustomTableCell>
	</CustomTableRow>
);

export default ToolRow;
